import { render } from "./members-subpage.vue?vue&type=template&id=083ecdf5"
import script from "./members-subpage.vue?vue&type=script&lang=js"
export * from "./members-subpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__